require('!modernizr!./.modernizrrc');
require('./polyfills.js');
require('apply!callback!./components.js');
